<template lang="html">
  <div class="numberdisplay">
    <v-row>
      <v-col cols="12" class="">
        <div class="number" :class="{'green--text text--darken-2': result ? true : false}">
          {{number}}
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data(){
    return{
      number: null,
      numbers: [],
      result: null,
      method: this.$store.getters.method,
      digits: this.$store.getters.digits,
      speed: this.$store.getters.speed,
      steps: this.$store.getters.steps,
    }
  },
  methods: {
    getNumber(digits){
      let min = 10
      let max = 99
      if (digits===1) {
        min = 1
        max = 9
      }
      if (digits===3) {
        min = 100
        max = 999
      }
      if (digits===4) {
        min = 1000
        max = 9999
      }
      if (digits===5) {
        min = 10000
        max = 99999
      }
      return Math.floor(Math.random() * (max - min + 1) ) + min;  // min and max are included
    },
    getRandomMethod(){
      let rdn = Math.round(Math.random())
      return rdn===0 ? -1 : 1;
    },
    async startSoroban(){

      //set up large number for subtractions
      if(this.method==='kivonás' || this.method==='vegyes'){
        this.numbers.push(Math.pow(10,this.digits+1))
      }
      //get the numbers
      let i = 0
      while(i<this.steps){
        let num = this.getNumber(this.digits);
        if(this.method==='kivonás'){
          num *= -1;
        }
        else if(this.method==='vegyes'){
          num *= this.getRandomMethod();
        }
        this.numbers.push(num);
        i +=1
      }

      await this.sleep(2000)

      for (let j = 0; j < this.numbers.length; j++) {
        this.number = null;
        await this.sleep((this.speed*1000)/3.5)
        let num = this.numbers[j]
        if(j!==0&&num>0){
          num = "+" + num;
        }
        this.number = num;
        await this.sleep((this.speed*1000)/3.5)
      }

      this.number = null;
      await this.sleep(this.speed*1000)
      this.result = this.numbers.reduce((a,b)=>(a+b),0)
      this.number = this.result;
      await this.sleep(3000);
      this.resetData();

    },
    sleep(ms){
       return new Promise(resolve => setTimeout(resolve, ms));
    },
    resetData(){
      this.number = null;
      this.numbers = [];
      this.result = null;
      this.startSoroban();
    }
  },
  mounted(){
    this.startSoroban();
  }

}
</script>

<style lang="scss" scoped>
.numberdisplay{
  max-width: 700px;
  height: 70vh;
  margin-left: auto;
  margin-right: auto;
  border: 15px solid #BA68C8;
  border-radius: 20px;


  &>.row{
    height: 100%;
  }
  & .col{
    display: flex;
    justify-content: center;
    background-color: #F3E5F5;
    border-radius: 20px;
  }

  .number{
      color: #4A148C;
      font-size: 10rem;
      margin: auto 0;

      @media(max-width: 600px){
        font-size: 5rem;
      }
  }

}

</style>
